module.exports = __webpack_public_path__ + "img/icon-back.b61a9f66.svg";